import { getJsonFromUrl } from ".";

export function isChannelCPS() {
    const { st, is_promote_flag, is_resell_center, sid, nsid } = getJsonFromUrl()
    return st === 'channel_cps' || is_resell_center === 'True' || is_promote_flag === 'true' || sid || nsid
}


// WEBPACK FOOTER //
// ./src/utils/cps.js